import {
    getAppliedCampaignsFiltersTotalCount,
    getAvailableCampaignStatuses,
} from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/utils';

import { CampaignsTab } from 'store/models/campaignsDashboard';
import {
    CampaignFilter,
    setAppliedCampaignsFilters,
    setAppliedCampaignsFiltersTotalCount,
    setCampaignsFiltersDraft,
} from 'store/models/campaignsFilters';
import { AppThunkAction } from 'store/utils';

export const resetUnavailableCampaignStatusFilter =
    (tab: CampaignsTab): AppThunkAction<void> =>
    (dispatch, getState) => {
        const { appliedCampaignsFilters, campaignsFiltersDraft } = getState().campaignsFilters;
        const availableStatuses = getAvailableCampaignStatuses(tab);
        const keepAvailableStatuses = (statuses: Set<string>) =>
            new Set([...statuses].filter((status) => availableStatuses.includes(status)));

        const appliedStatuses = keepAvailableStatuses(appliedCampaignsFilters.campaignStatuses);
        if (appliedStatuses.size === appliedCampaignsFilters.campaignStatuses.size) {
            return;
        }

        const filters = { ...appliedCampaignsFilters, [CampaignFilter.CampaignStatuses]: appliedStatuses };

        dispatch([
            setAppliedCampaignsFilters(filters),
            setAppliedCampaignsFiltersTotalCount(getAppliedCampaignsFiltersTotalCount(filters)),
            setCampaignsFiltersDraft({
                ...campaignsFiltersDraft,
                [CampaignFilter.CampaignStatuses]: keepAvailableStatuses(campaignsFiltersDraft.campaignStatuses),
            }),
        ]);
    };
